<script setup lang="ts">
import { useTitle } from '@vueuse/core';

useTitle('Page Not Found');

const error = {
  statusCode: 404,
  statusMessage: 'Not found',
  message: 'The page you\'re looking for doesn\'t exist.',
};
</script>

<template>
  <UError
    :error="error"
    :clear="false"
    data-testid="error-page-404"
  >
    <template #links>
      <RouterLink :to="{ name: 'Home' }">
        <UButton
          size="lg"
          color="primary"
          label="Go home"
          data-testid="error-back-to-home-button"
        />
      </RouterLink>
    </template>
  </UError>
</template>
